import {Path, Rect, Svg, Circle} from 'react-native-svg';

const LanguageIcon = () => (
  <Svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <Rect width="30" height="30" rx="7" fill="#34C759" />

    {/* Globe outline */}
    <Circle cx="15" cy="15" r="8" stroke="white" strokeWidth="1.5" fill="none" />

    {/* Vertical line through center */}
    <Path d="M15 7V23" stroke="white" strokeWidth="1.5" />

    {/* Horizontal lines (latitude) */}
    <Path d="M7 15H23" stroke="white" strokeWidth="1.5" />
    <Path d="M9 11H21" stroke="white" strokeWidth="1" />
    <Path d="M9 19H21" stroke="white" strokeWidth="1" />

    {/* Curved lines (longitude) */}
    <Path d="M15 7C12.5 10 12.5 20 15 23" stroke="white" strokeWidth="1" fill="none" />
    <Path d="M15 7C17.5 10 17.5 20 15 23" stroke="white" strokeWidth="1" fill="none" />
  </Svg>
);

export default LanguageIcon;
